var map = {
	"./svg/Assets-icon.svg": 9162,
	"./svg/AvgGain-chart-icon.svg": 31875,
	"./svg/Badges-icon.svg": 13983,
	"./svg/Camera.svg": 28954,
	"./svg/Charts/area.svg": 85300,
	"./svg/Charts/bar.svg": 64742,
	"./svg/Charts/candlestick.svg": 5848,
	"./svg/Charts/doughnut.svg": 70005,
	"./svg/Charts/line.svg": 87109,
	"./svg/Charts/pie.svg": 38623,
	"./svg/Charts/poll.svg": 40360,
	"./svg/Create Post_Share.svg": 95331,
	"./svg/Create Post_Shorttext.svg": 40833,
	"./svg/Edit-Section-icon.svg": 55061,
	"./svg/Header_Cart.svg": 51669,
	"./svg/Header_Expand.svg": 20019,
	"./svg/Header_Logo.svg": 96062,
	"./svg/Header_Logo_01.svg": 50540,
	"./svg/Header_Notification.svg": 60490,
	"./svg/Header_Search.svg": 88363,
	"./svg/Header_Setting.svg": 19057,
	"./svg/Header_Wallet.svg": 57924,
	"./svg/Highlights-section-icon.svg": 2588,
	"./svg/Icon-circle-x.svg": 20646,
	"./svg/Icon-messenger-share.svg": 96308,
	"./svg/Icon-vertical-dot.svg": 59681,
	"./svg/Interests-icon.svg": 94178,
	"./svg/Logo_grey.svg": 18248,
	"./svg/NotificationsIcons/chartAndanalysis.svg": 47237,
	"./svg/NotificationsIcons/eTrade.svg": 34057,
	"./svg/NotificationsIcons/favouritePlatform.svg": 69284,
	"./svg/NotificationsIcons/pages.svg": 80720,
	"./svg/NotificationsIcons/predicition.svg": 10640,
	"./svg/NotificationsIcons/quoted.svg": 34520,
	"./svg/NotificationsIcons/topGainers.svg": 63832,
	"./svg/NotificationsIcons/traderverse.svg": 9163,
	"./svg/Performance-ico.svg": 3687,
	"./svg/Portfolio_Post_Timeline.svg": 53080,
	"./svg/Post_Location.svg": 77693,
	"./svg/Post_Shorttext.svg": 20043,
	"./svg/Post_Smiley.svg": 717,
	"./svg/Post_User.svg": 79193,
	"./svg/Profile.svg": 18042,
	"./svg/Profile_Tabs/About.svg": 22123,
	"./svg/Profile_Tabs/Accounts.svg": 74464,
	"./svg/Profile_Tabs/Connections.svg": 97543,
	"./svg/Profile_Tabs/Edit-Profile.svg": 78640,
	"./svg/Profile_Tabs/Investments.svg": 40514,
	"./svg/Profile_Tabs/Timeline.svg": 24253,
	"./svg/S&PBeat-chart-icon.svg": 9575,
	"./svg/Section-share-logo.svg": 46598,
	"./svg/Send_Icon.svg": 9051,
	"./svg/Share-Profile-icon.svg": 80258,
	"./svg/TotalGains-chart-icon.svg": 8448,
	"./svg/Trade-icon.svg": 91287,
	"./svg/View-all.svg": 14182,
	"./svg/Watchlist-icon.svg": 55314,
	"./svg/WinRate-chart-icon.svg": 9244,
	"./svg/account.svg": 43948,
	"./svg/add-and-edit-icon-widget.svg": 51298,
	"./svg/add-friend-outline.svg": 80104,
	"./svg/add-friend-profile.svg": 14505,
	"./svg/add-icon-cover.svg": 73168,
	"./svg/add-icon.svg": 41462,
	"./svg/add-media-icon.svg": 2011,
	"./svg/add-page-icon.svg": 73810,
	"./svg/add-widget-popup/icon-01.svg": 29464,
	"./svg/add-widget-popup/icon-02.svg": 68299,
	"./svg/add-widget-popup/icon-03.svg": 63034,
	"./svg/add-widget-popup/icon-04.svg": 97957,
	"./svg/add_widget/Charts.svg": 70669,
	"./svg/add_widget/Cover.svg": 23739,
	"./svg/add_widget/CustomGrid.svg": 10271,
	"./svg/add_widget/CustomList.svg": 14143,
	"./svg/add_widget/CustomTable.svg": 12881,
	"./svg/add_widget/Grid.svg": 34822,
	"./svg/add_widget/List.svg": 18762,
	"./svg/add_widget/Table.svg": 55778,
	"./svg/add_widget/Watchlist.svg": 83071,
	"./svg/add_widget/clip-widget-tile.svg": 95938,
	"./svg/add_widget/custom-grid.svg": 69452,
	"./svg/add_widget/custom-list.svg": 15108,
	"./svg/add_widget/executive_profile.e0e456ef.png": 51696,
	"./svg/add_widget/icon-crypto.svg": 31393,
	"./svg/add_widget/icon-nft-light.svg": 63085,
	"./svg/add_widget/icon-nft.svg": 75062,
	"./svg/add_widget/icon-signal-light.svg": 22705,
	"./svg/add_widget/icon-signal.svg": 15930,
	"./svg/add_widget/icon-signals.svg": 94309,
	"./svg/add_widget/icon-social-light.svg": 28596,
	"./svg/add_widget/icon-social-media.svg": 1636,
	"./svg/add_widget/icon-social.svg": 91463,
	"./svg/add_widget/icon-sort.5ac6fd1b.svg": 48526,
	"./svg/add_widget/icon-stock-and-crypto.svg": 83874,
	"./svg/add_widget/icon-stock-light.svg": 37947,
	"./svg/add_widget/icon-stock.svg": 25296,
	"./svg/add_widget/strikeThrough.9576ba40.svg": 42585,
	"./svg/addsectionicon/Trading-Interests_item.svg": 70872,
	"./svg/addsectionicon/favouriteInfluencer_item.svg": 88535,
	"./svg/addsectionicon/favouriteInvestment_item.svg": 85165,
	"./svg/addsectionicon/images_item.svg": 93327,
	"./svg/addsectionicon/links_item.svg": 4146,
	"./svg/addsectionicon/playbook_item.svg": 610,
	"./svg/addsectionicon/points_item.svg": 69414,
	"./svg/addsectionicon/portfolio_item.svg": 87319,
	"./svg/addsectionicon/predictions_item.svg": 17053,
	"./svg/addsectionicon/profitAndLoss_item.svg": 9459,
	"./svg/addsectionicon/recommendation_item.svg": 40722,
	"./svg/addsectionicon/topStats_item.svg": 74927,
	"./svg/addsectionicon/traderType_item.svg": 94713,
	"./svg/addsectionicon/watchlists_item.svg": 87185,
	"./svg/addsectionicon/winningTrades_item.svg": 13700,
	"./svg/advance-filters/media-icon.svg": 55290,
	"./svg/advance-filters/quote-icon.svg": 99234,
	"./svg/advance-filters/text-icon.svg": 38741,
	"./svg/angle-down.svg": 65993,
	"./svg/angle-right.svg": 79657,
	"./svg/arrow-down.svg": 89771,
	"./svg/arrow-left.svg": 85612,
	"./svg/asset.svg": 11369,
	"./svg/auth/envelope-white.svg": 68508,
	"./svg/auth/envelope.svg": 5996,
	"./svg/auth/fb.svg": 10624,
	"./svg/auth/google.svg": 23293,
	"./svg/auth/hide-white.svg": 86944,
	"./svg/auth/hide.svg": 53168,
	"./svg/auth/phone-white.svg": 60412,
	"./svg/auth/phone.svg": 52844,
	"./svg/auth/simple-close-icon.svg": 48741,
	"./svg/auth/tick.svg": 91175,
	"./svg/auth/view-white.svg": 38187,
	"./svg/auth/view.svg": 2971,
	"./svg/auth/x.svg": 70680,
	"./svg/auth_logo.svg": 52837,
	"./svg/award-icon.svg": 49404,
	"./svg/back-ero.svg": 3009,
	"./svg/back-icon-cover.svg": 24386,
	"./svg/back-page-chnage.svg": 46341,
	"./svg/backPage-icon.svg": 20935,
	"./svg/badge-1.svg": 55078,
	"./svg/badge-2.svg": 54213,
	"./svg/badge-3.svg": 99492,
	"./svg/badge-one-icon.svg": 43707,
	"./svg/badge-three-icon.svg": 65931,
	"./svg/badge-two-icon.svg": 39673,
	"./svg/billing-action.svg": 95963,
	"./svg/block.svg": 22542,
	"./svg/box-1.svg": 13156,
	"./svg/box-2.svg": 67607,
	"./svg/box-3.svg": 62278,
	"./svg/box-4.svg": 48041,
	"./svg/box-5.svg": 22680,
	"./svg/calendar-feather-icon.svg": 44015,
	"./svg/calendar-icon.svg": 25649,
	"./svg/cancel-request-button.svg": 78834,
	"./svg/cancel-request-outline.svg": 83800,
	"./svg/category-filter.svg": 62946,
	"./svg/center-side-place-02.svg": 82001,
	"./svg/center-side-place-03.svg": 46048,
	"./svg/center-side-place.svg": 26722,
	"./svg/chat.svg": 78745,
	"./svg/check-green-icon.svg": 98311,
	"./svg/check-icon.svg": 94889,
	"./svg/chevron-right.svg": 59777,
	"./svg/circle-logo.svg": 1825,
	"./svg/close-circle.svg": 56590,
	"./svg/close-icon.svg": 16645,
	"./svg/close-times.svg": 88568,
	"./svg/coin-dollar.svg": 28151,
	"./svg/coin.svg": 5596,
	"./svg/company/company-icon.svg": 67730,
	"./svg/company/dollar-icon.svg": 45269,
	"./svg/company/dollar.svg": 74465,
	"./svg/company/employee-icon.svg": 72515,
	"./svg/company/exchange-icon.svg": 42726,
	"./svg/company/globe-icon.svg": 72132,
	"./svg/company/home-icon.svg": 75088,
	"./svg/company/link-icon.svg": 2491,
	"./svg/company/news-icon.svg": 85624,
	"./svg/company/pin-icon.svg": 86234,
	"./svg/company/placeholder-logo.svg": 9298,
	"./svg/company/public-icon.svg": 59366,
	"./svg/company/public.svg": 21684,
	"./svg/company/record-icon.svg": 40458,
	"./svg/company/sector-icon.svg": 34413,
	"./svg/contact-us.svg": 61222,
	"./svg/container-coming-soon.svg": 72064,
	"./svg/copy-link.svg": 92461,
	"./svg/create-post.svg": 16518,
	"./svg/create_post/Create Post_Analysis.svg": 47888,
	"./svg/create_post/Create Post_Analysis_three.svg": 97689,
	"./svg/create_post/Create Post_Analysis_two.svg": 539,
	"./svg/create_post/Create Post_Chart.svg": 5746,
	"./svg/create_post/Create Post_Charts.svg": 51181,
	"./svg/create_post/Create Post_Copy.svg": 44621,
	"./svg/create_post/Create Post_Globe.svg": 86157,
	"./svg/create_post/Create Post_Link.svg": 64454,
	"./svg/create_post/Create Post_Location.svg": 5259,
	"./svg/create_post/Create Post_Long Text.svg": 38305,
	"./svg/create_post/Create Post_Media.svg": 49358,
	"./svg/create_post/Create Post_Pdf_Two.svg.svg": 38451,
	"./svg/create_post/Create Post_Profile.svg": 81117,
	"./svg/create_post/Create Post_Profile_Three.svg": 24024,
	"./svg/create_post/Create Post_Profile_Two.svg": 98246,
	"./svg/create_post/Create Post_Share.svg": 80195,
	"./svg/create_post/Create Post_Shorttext.svg": 98913,
	"./svg/create_post/Create Post_Text Four.svg": 56109,
	"./svg/create_post/Create Post_Text.svg": 19411,
	"./svg/create_post/Create Post_Text_Three.svg": 12302,
	"./svg/create_post/Create Post_Text_Two.svg": 64336,
	"./svg/create_post/Create Post_Trades.svg": 91219,
	"./svg/create_post/Create Post_Trades_two.svg": 70256,
	"./svg/create_post/Create Post_User.svg": 83599,
	"./svg/create_post/Create Post_Watchlist.svg": 95103,
	"./svg/create_post/_icon_emoj_two_createpost.svg": 1163,
	"./svg/create_post/addIcon.svg": 71615,
	"./svg/create_post/attachment.svg": 54744,
	"./svg/create_post/chart.svg": 27033,
	"./svg/create_post/chartsIcon.svg": 77411,
	"./svg/create_post/gallery-add.svg": 67457,
	"./svg/create_post/icon-categorical.svg": 45439,
	"./svg/create_post/icon-compare.svg": 45250,
	"./svg/create_post/icon-detail-watchlist.svg": 31844,
	"./svg/create_post/icon-detail.svg": 44242,
	"./svg/create_post/icon-emoji.svg": 11049,
	"./svg/create_post/icon-forecast.svg": 89706,
	"./svg/create_post/icon-gallery.svg": 10233,
	"./svg/create_post/icon-gif.svg": 47445,
	"./svg/create_post/icon-highlight.svg": 21535,
	"./svg/create_post/icon-highlights.svg": 6782,
	"./svg/create_post/icon-mic.svg": 92046,
	"./svg/create_post/icon-poll.svg": 44714,
	"./svg/create_post/icon-prediction.svg": 68082,
	"./svg/create_post/icon-predictions.svg": 74893,
	"./svg/create_post/icon-price.svg": 82608,
	"./svg/create_post/icon-regular-watchlist.svg": 85213,
	"./svg/create_post/icon-select-portfolio.svg": 44954,
	"./svg/create_post/icon-stats.svg": 84022,
	"./svg/create_post/icon-summary-two.svg": 16714,
	"./svg/create_post/icon-summary.svg": 20235,
	"./svg/create_post/icon-technical.svg": 98878,
	"./svg/create_post/icon-transaction.svg": 86243,
	"./svg/create_post/icon_emoj_createpost.svg": 56735,
	"./svg/create_post/icon_emoji.svg": 55567,
	"./svg/create_post/icon_gif_createpost.svg": 48920,
	"./svg/create_post/icon_left_chevron.svg": 32240,
	"./svg/create_post/icon_location_createpost.svg": 9919,
	"./svg/create_post/icon_media_createpost.svg": 66798,
	"./svg/create_post/icon_search_location.svg": 87939,
	"./svg/create_post/media-icon.svg": 4101,
	"./svg/create_post/new-icon.svg": 53855,
	"./svg/create_post/quote-icon.svg": 60409,
	"./svg/create_post/share_icon_linkdin_create_post.svg": 90124,
	"./svg/create_post/share_icon_traderverse_create_post.svg": 5234,
	"./svg/create_post/share_icon_twitter_create_post.svg": 68404,
	"./svg/create_post/share_icon_x_create_post.svg": 17633,
	"./svg/create_post/text-feeling.svg": 50077,
	"./svg/create_post/text-icon.svg": 1588,
	"./svg/create_post/text-long.svg": 35525,
	"./svg/create_post/text-paged-two.svg": 2163,
	"./svg/create_post/text-paged-white.svg": 8050,
	"./svg/create_post/text-paged.svg": 17014,
	"./svg/create_post/text-predict.svg": 61594,
	"./svg/create_post/text-quoted.svg": 36895,
	"./svg/create_post/text-short.svg": 54027,
	"./svg/create_post/watchlists.svg": 77795,
	"./svg/date-icon.svg": 93783,
	"./svg/delete-icon.svg": 75392,
	"./svg/discord.svg": 95533,
	"./svg/dollar-circle.svg": 7370,
	"./svg/dot-icon.svg": 76290,
	"./svg/dropdown.svg": 19848,
	"./svg/edit-1-svgrepo-com.svg": 49276,
	"./svg/edit-1-svgrepo-com2.svg": 95334,
	"./svg/edit-card.svg": 70454,
	"./svg/edit-icon-cover.svg": 64065,
	"./svg/edit-icon-profile-info-dv.svg": 66835,
	"./svg/edit-icon-profile-info-two-dv.svg": 94252,
	"./svg/email-icon.svg": 21865,
	"./svg/empty_chat.svg": 22087,
	"./svg/etrade-logo.svg": 64986,
	"./svg/explore/icon-companies.svg": 48942,
	"./svg/explore/icon-crypto.svg": 2710,
	"./svg/explore/icon-groups.svg": 86545,
	"./svg/explore/icon-influencer.svg": 12232,
	"./svg/explore/icon-news.svg": 10312,
	"./svg/explore/icon-nfts.svg": 59222,
	"./svg/explore/icon-stocks.svg": 43900,
	"./svg/eye-icon.svg": 6736,
	"./svg/facebook.svg": 27355,
	"./svg/fb-icon.svg": 97071,
	"./svg/feather-eye-icon.svg": 32562,
	"./svg/feelings/Angry.svg": 61154,
	"./svg/feelings/Blessed.svg": 44139,
	"./svg/feelings/Cool.svg": 28868,
	"./svg/feelings/Crazy.svg": 77722,
	"./svg/feelings/Excited.svg": 27815,
	"./svg/feelings/Fantastic.svg": 47318,
	"./svg/feelings/Grateful.svg": 30549,
	"./svg/feelings/Happy.svg": 50163,
	"./svg/feelings/In Love.svg": 51270,
	"./svg/feelings/Loved.svg": 55397,
	"./svg/feelings/Lovely.svg": 94670,
	"./svg/feelings/Relaxed.svg": 37092,
	"./svg/feelings/Sad.svg": 61789,
	"./svg/feelings/Thankful.svg": 57578,
	"./svg/fire_icon.svg": 85085,
	"./svg/following-icon.svg": 75370,
	"./svg/forw-page-change.svg": 24010,
	"./svg/forward.svg": 64838,
	"./svg/frind-add-icon.svg": 80046,
	"./svg/gallery-add.svg": 40897,
	"./svg/game-icon.svg": 92233,
	"./svg/google.svg": 43826,
	"./svg/header-menu-icons/analyzie/icon-analyze_alerts.svg": 79234,
	"./svg/header-menu-icons/analyzie/icon-analyze_birdeye.svg": 32473,
	"./svg/header-menu-icons/analyzie/icon-analyze_charting.svg": 39151,
	"./svg/header-menu-icons/analyzie/icon-analyze_charts.svg": 98896,
	"./svg/header-menu-icons/analyzie/icon-analyze_compare-boards.svg": 92698,
	"./svg/header-menu-icons/analyzie/icon-analyze_overview.svg": 29358,
	"./svg/header-menu-icons/analyzie/icon-analyze_papers.svg": 38354,
	"./svg/header-menu-icons/analyzie/icon-analyze_screener.svg": 942,
	"./svg/header-menu-icons/analyzie/icon-analyze_watchlist.svg": 75880,
	"./svg/header-menu-icons/explore/icon-explore_buzz.svg": 12655,
	"./svg/header-menu-icons/explore/icon-explore_glossary_list.svg": 85103,
	"./svg/header-menu-icons/explore/icon-explore_market.svg": 36948,
	"./svg/header-menu-icons/explore/icon-explore_news.svg": 35297,
	"./svg/header-menu-icons/explore/icon-explore_papers.svg": 97757,
	"./svg/header-menu-icons/explore/icon-explore_people.svg": 26485,
	"./svg/header-menu-icons/explore/icon-explore_symbol.svg": 33056,
	"./svg/header-menu-icons/explore/icon-explore_trends.svg": 63120,
	"./svg/header-menu-icons/explore/icon-explore_wiki.svg": 27880,
	"./svg/header-menu-icons/socialize/icon-analytics.svg": 91328,
	"./svg/header-menu-icons/socialize/icon-assets.svg": 33707,
	"./svg/header-menu-icons/socialize/icon-chat.svg": 96858,
	"./svg/header-menu-icons/socialize/icon-discussion.svg": 61592,
	"./svg/header-menu-icons/socialize/icon-eye.svg": 32167,
	"./svg/header-menu-icons/socialize/icon-feed.svg": 2452,
	"./svg/header-menu-icons/socialize/icon-globe.svg": 56511,
	"./svg/header-menu-icons/socialize/icon-info-circle.svg": 58257,
	"./svg/header-menu-icons/socialize/icon-media.svg": 2540,
	"./svg/header-menu-icons/socialize/icon-members.svg": 33241,
	"./svg/header-menu-icons/socialize/icon-refresh.svg": 49121,
	"./svg/header-menu-icons/socialize/icon-setting.svg": 25524,
	"./svg/header-menu-icons/socialize/icon-socialize_chats.svg": 67937,
	"./svg/header-menu-icons/socialize/icon-socialize_club.svg": 78248,
	"./svg/header-menu-icons/socialize/icon-socialize_club_pink.svg": 68695,
	"./svg/header-menu-icons/socialize/icon-socialize_discussions.svg": 94911,
	"./svg/header-menu-icons/socialize/icon-socialize_ranking.svg": 76834,
	"./svg/header-menu-icons/themes/theme_dark.svg": 12679,
	"./svg/header-menu-icons/themes/theme_default.svg": 11730,
	"./svg/header-menu-icons/themes/theme_light.svg": 72021,
	"./svg/header_name_logo_alpha.svg": 2565,
	"./svg/header_name_logo_live.svg": 71041,
	"./svg/header_search_icons/crypto.svg": 30100,
	"./svg/header_search_icons/glossary.svg": 31819,
	"./svg/header_search_icons/icons-04.svg": 72020,
	"./svg/header_search_icons/icons-05.svg": 16949,
	"./svg/header_search_icons/people.svg": 57534,
	"./svg/header_search_icons/stock.svg": 90555,
	"./svg/help-icon.svg": 80912,
	"./svg/hide-icon.svg": 49835,
	"./svg/home_stats/icon-accounts.svg": 59487,
	"./svg/home_stats/icon-assets.svg": 57792,
	"./svg/home_stats/icon-coin.svg": 54660,
	"./svg/home_stats/icon-medal.svg": 55428,
	"./svg/home_stats/icon-profile.svg": 51666,
	"./svg/home_stats/icon-receipt.svg": 61513,
	"./svg/ico-earth-globe.svg": 89893,
	"./svg/icon-012.svg": 7334,
	"./svg/icon-013.svg": 96311,
	"./svg/icon-1.svg": 29230,
	"./svg/icon-2.svg": 58349,
	"./svg/icon-3.svg": 78636,
	"./svg/icon-Left-Chevron.svg": 17164,
	"./svg/icon-PM.svg": 12216,
	"./svg/icon-Right-Chevron.svg": 66415,
	"./svg/icon-accept.svg": 87321,
	"./svg/icon-account.svg": 35662,
	"./svg/icon-accuracy.svg": 78714,
	"./svg/icon-add-circuar-border.svg": 34625,
	"./svg/icon-add-outlined.svg": 73265,
	"./svg/icon-add-playbook.svg": 77666,
	"./svg/icon-add-white.svg": 91370,
	"./svg/icon-add.svg": 44190,
	"./svg/icon-addFriend.svg": 79050,
	"./svg/icon-arrow-back.svg": 80820,
	"./svg/icon-arrow-up.svg": 90858,
	"./svg/icon-back-info-playbook.svg": 67459,
	"./svg/icon-back.svg": 54976,
	"./svg/icon-badge-leaderboard.svg": 67616,
	"./svg/icon-button-following.svg": 66919,
	"./svg/icon-button-unfollowing.svg": 90256,
	"./svg/icon-buzz-company.svg": 98772,
	"./svg/icon-buzz-crypto.svg": 14328,
	"./svg/icon-buzz-guide.svg": 2737,
	"./svg/icon-buzz-joined.svg": 89784,
	"./svg/icon-buzz-news.svg": 40186,
	"./svg/icon-buzz-stocks.svg": 74710,
	"./svg/icon-camera.info.dark.svg": 75536,
	"./svg/icon-camera.info.svg": 29046,
	"./svg/icon-camera.svg": 9592,
	"./svg/icon-chart.svg": 42459,
	"./svg/icon-chat-attachment.svg": 86275,
	"./svg/icon-chat-emoji.svg": 26614,
	"./svg/icon-chat-media.svg": 63392,
	"./svg/icon-chat-mute.svg": 44623,
	"./svg/icon-check.svg": 47923,
	"./svg/icon-chevron-left.svg": 29056,
	"./svg/icon-circles.svg": 66244,
	"./svg/icon-clock-leaderboard.svg": 63495,
	"./svg/icon-clock-search.svg": 54062,
	"./svg/icon-clock-watchlist.svg": 24327,
	"./svg/icon-close-circle.svg": 44548,
	"./svg/icon-close-circlefff.svg": 3566,
	"./svg/icon-close-playbook.svg": 57365,
	"./svg/icon-close-popup.svg": 87982,
	"./svg/icon-close-search.svg": 53916,
	"./svg/icon-closing-remove.svg": 22939,
	"./svg/icon-code.svg": 49394,
	"./svg/icon-copy-share.svg": 99764,
	"./svg/icon-dark-mode.svg": 53543,
	"./svg/icon-delete-info.svg": 56605,
	"./svg/icon-delete-playbook-button.svg": 23137,
	"./svg/icon-discord-share.svg": 38593,
	"./svg/icon-doc-text.svg": 8571,
	"./svg/icon-double-tick.svg": 82244,
	"./svg/icon-down-playbook.svg": 65331,
	"./svg/icon-download.svg": 33793,
	"./svg/icon-dropdown.svg": 82674,
	"./svg/icon-dummy-portfolio.svg": 27788,
	"./svg/icon-edit-new.svg": 43660,
	"./svg/icon-edit-playbook-button.svg": 34336,
	"./svg/icon-edit-profile-button.svg": 53426,
	"./svg/icon-email-share.svg": 52353,
	"./svg/icon-email.svg": 13407,
	"./svg/icon-enter.svg": 96865,
	"./svg/icon-envelope.svg": 36009,
	"./svg/icon-eye-off.svg": 74636,
	"./svg/icon-eye-watchlist.svg": 20894,
	"./svg/icon-eye.svg": 79400,
	"./svg/icon-facebook-share.svg": 70331,
	"./svg/icon-favouriteTraders.svg": 38013,
	"./svg/icon-file.svg": 49987,
	"./svg/icon-filter-all.svg": 34077,
	"./svg/icon-filter-icon.svg": 79279,
	"./svg/icon-filter-price.svg": 56027,
	"./svg/icon-filter-ticker.svg": 40030,
	"./svg/icon-filter-user.svg": 87397,
	"./svg/icon-filter-watchlist.svg": 77469,
	"./svg/icon-filter.svg": 96299,
	"./svg/icon-follow-button.svg": 24392,
	"./svg/icon-follow.svg": 98038,
	"./svg/icon-followers.svg": 50390,
	"./svg/icon-following.svg": 58530,
	"./svg/icon-forwarded-auth.svg": 41634,
	"./svg/icon-friends.svg": 33912,
	"./svg/icon-globe.svg": 58740,
	"./svg/icon-guilds-friends.svg": 73717,
	"./svg/icon-guilds-rating.svg": 72233,
	"./svg/icon-hamburger-menu.svg": 28250,
	"./svg/icon-handle-sign-up.svg": 22487,
	"./svg/icon-handle.svg": 5139,
	"./svg/icon-header-01.svg": 13466,
	"./svg/icon-header-02.svg": 28553,
	"./svg/icon-header-messages-chat.svg": 19478,
	"./svg/icon-images.svg": 61799,
	"./svg/icon-info-circle.svg": 52302,
	"./svg/icon-info-dropdown-filters.svg": 49159,
	"./svg/icon-info.svg": 50737,
	"./svg/icon-instagram-share.svg": 28885,
	"./svg/icon-investment.svg": 59330,
	"./svg/icon-kebab.svg": 16284,
	"./svg/icon-layout-grid-1.svg": 63358,
	"./svg/icon-layout-grid-2.svg": 75453,
	"./svg/icon-leaderboard-dv.svg": 38181,
	"./svg/icon-light-mode.svg": 52357,
	"./svg/icon-link.svg": 33481,
	"./svg/icon-linkedin-share.svg": 55985,
	"./svg/icon-links.svg": 60968,
	"./svg/icon-list.svg": 73517,
	"./svg/icon-lock-profile.svg": 86184,
	"./svg/icon-lock.svg": 5600,
	"./svg/icon-message-share.svg": 94628,
	"./svg/icon-message.svg": 97362,
	"./svg/icon-messages-request-info-two.svg": 30739,
	"./svg/icon-minus-playbook.svg": 98453,
	"./svg/icon-modal-edit.svg": 21097,
	"./svg/icon-modal-trash.svg": 68977,
	"./svg/icon-modal-view.svg": 49598,
	"./svg/icon-new-log.svg": 12228,
	"./svg/icon-new.svg": 26117,
	"./svg/icon-next-info-dv.svg": 78998,
	"./svg/icon-next-profile-icon.svg": 50760,
	"./svg/icon-not-found.svg": 76171,
	"./svg/icon-not-info.svg": 28409,
	"./svg/icon-outline-check.svg": 35878,
	"./svg/icon-password.svg": 86778,
	"./svg/icon-photo_profile.svg": 85125,
	"./svg/icon-playbook-add.svg": 76518,
	"./svg/icon-playbook-long.svg": 82291,
	"./svg/icon-playbook-minus.svg": 74495,
	"./svg/icon-playbook-short.svg": 7317,
	"./svg/icon-playbook-stockactualprice.svg": 99650,
	"./svg/icon-playbook-stocknotes.svg": 32624,
	"./svg/icon-playbook-stockstopprice.svg": 88116,
	"./svg/icon-playbook-stocktargetoneprice.svg": 30733,
	"./svg/icon-playbook-stocktargetonepriceShort.svg": 36837,
	"./svg/icon-playbook-stocktargettwoprice.svg": 91739,
	"./svg/icon-playbook-stocktargettwopriceshort.svg": 35651,
	"./svg/icon-playbook.svg": 17432,
	"./svg/icon-plus.svg": 3081,
	"./svg/icon-portfolio-heading.svg": 17698,
	"./svg/icon-portfolios.svg": 13870,
	"./svg/icon-predictions.svg": 29773,
	"./svg/icon-previous-info-dv.svg": 57106,
	"./svg/icon-previous-profile-icon.svg": 1092,
	"./svg/icon-profile-lock-private.svg": 68774,
	"./svg/icon-profitLoss.svg": 92262,
	"./svg/icon-qr-code-back.svg": 76650,
	"./svg/icon-qr-code-export.svg": 9381,
	"./svg/icon-qrcode.svg": 82607,
	"./svg/icon-ranking-01-icon-bottom.svg": 2757,
	"./svg/icon-ranking-01-icon-top.svg": 12589,
	"./svg/icon-ranking-02-icon-bottom.svg": 92174,
	"./svg/icon-ranking-03-icon-bottom.svg": 51347,
	"./svg/icon-ranking-04-icon-bottom.svg": 79100,
	"./svg/icon-ranking-05-icon-bottom.svg": 53585,
	"./svg/icon-rating.svg": 17234,
	"./svg/icon-recommendation.svg": 61672,
	"./svg/icon-reddit-share.svg": 75515,
	"./svg/icon-reject.svg": 61060,
	"./svg/icon-remove-circular.svg": 86213,
	"./svg/icon-scan-gallery.svg": 26771,
	"./svg/icon-search-crox.svg": 52184,
	"./svg/icon-search-filter.svg": 67880,
	"./svg/icon-section-c.svg": 57766,
	"./svg/icon-section.svg": 14830,
	"./svg/icon-share-logo-traderverse.svg": 77526,
	"./svg/icon-share-profile.svg": 36198,
	"./svg/icon-sign-check.svg": 79021,
	"./svg/icon-sign-plus.svg": 42215,
	"./svg/icon-signin.svg": 55191,
	"./svg/icon-slack-share.svg": 91245,
	"./svg/icon-social-fb.svg": 96753,
	"./svg/icon-social-google.svg": 43960,
	"./svg/icon-social-twitter.svg": 54574,
	"./svg/icon-stock-briefcase.svg": 63330,
	"./svg/icon-stock-map.svg": 75212,
	"./svg/icon-stock-popup-marker-two.svg": 80498,
	"./svg/icon-stock-popup-marker.svg": 29715,
	"./svg/icon-subscribers.svg": 72578,
	"./svg/icon-symbol.svg": 99229,
	"./svg/icon-target-playbook.svg": 88266,
	"./svg/icon-telegram-share.svg": 49954,
	"./svg/icon-theme.svg": 67832,
	"./svg/icon-tick-info-dv-two.svg": 84643,
	"./svg/icon-tick-info-dv.svg": 29734,
	"./svg/icon-tick-playbook.svg": 7214,
	"./svg/icon-time.svg": 50082,
	"./svg/icon-title.svg": 94477,
	"./svg/icon-topStats.svg": 13927,
	"./svg/icon-trade-orders.svg": 12809,
	"./svg/icon-trader.svg": 51273,
	"./svg/icon-trader.svg.svg": 38721,
	"./svg/icon-twitter.svg": 37390,
	"./svg/icon-user.svg": 79940,
	"./svg/icon-users.svg": 63439,
	"./svg/icon-vertical-dots.svg": 34736,
	"./svg/icon-watchlist.svg": 43574,
	"./svg/icon-whatsapp-share.svg": 34661,
	"./svg/icon-widget.svg": 24205,
	"./svg/icon-x-share.svg": 14553,
	"./svg/icon-x.svg": 24055,
	"./svg/icon-you.svg": 85722,
	"./svg/iconCloseSocial.svg": 45285,
	"./svg/icon_edit_button_on_profile.svg": 86816,
	"./svg/icon_reset_to_default.svg": 59502,
	"./svg/icon_showWidgets.svg": 32907,
	"./svg/iconinfoDv.svg": 94934,
	"./svg/info-circle.svg": 26604,
	"./svg/info-icon.svg": 59219,
	"./svg/infoIconNoData.svg": 25173,
	"./svg/insta-icon.svg": 71418,
	"./svg/instagram.svg": 56137,
	"./svg/left-side-par-02.svg": 69913,
	"./svg/left-side-par-03.svg": 73896,
	"./svg/left-side-par.svg": 33802,
	"./svg/linkdin.svg": 60620,
	"./svg/linkedin.svg": 66749,
	"./svg/lock-icon.svg": 38088,
	"./svg/lock.svg": 1614,
	"./svg/logo-icon.svg": 35408,
	"./svg/logo-private-icon.svg": 58606,
	"./svg/logo-txt.svg": 79261,
	"./svg/logo-white.svg": 39618,
	"./svg/logo.svg": 65318,
	"./svg/logo_black.svg": 44082,
	"./svg/logo_black_alpha.svg": 63927,
	"./svg/logout-icon.svg": 27037,
	"./svg/logout.svg": 13017,
	"./svg/mainChart-icon.svg": 81026,
	"./svg/minus.svg": 54189,
	"./svg/move.svg": 51364,
	"./svg/network-icon.svg": 32499,
	"./svg/new-calender-icon.svg": 47436,
	"./svg/new-log.svg": 22930,
	"./svg/new-portfolio-icon.svg": 99822,
	"./svg/new_menu.svg": 599,
	"./svg/new_search.svg": 14606,
	"./svg/news-icon.svg": 45036,
	"./svg/next-btn.svg": 94543,
	"./svg/noDataFound.svg": 45778,
	"./svg/nothing-placeholder.svg": 7590,
	"./svg/notification-icon.svg": 81996,
	"./svg/notifictaion.svg": 78896,
	"./svg/num-updown-icon.svg": 43397,
	"./svg/open_timelineTab.svg": 91456,
	"./svg/outlined_post_comment.svg": 95068,
	"./svg/overview/calendar-icon.svg": 65915,
	"./svg/overview/dollar-icon.svg": 37207,
	"./svg/overview/employee-icon.svg": 91073,
	"./svg/overview/glass-icon.svg": 76795,
	"./svg/overview/hq-icon.svg": 50478,
	"./svg/overview/industry-icon.svg": 50763,
	"./svg/overview/pin-icon.svg": 21036,
	"./svg/overview/sector-icon.svg": 19791,
	"./svg/overview/shop-icon.svg": 98885,
	"./svg/overview/website-icon.svg": 60262,
	"./svg/p-edit.svg": 59430,
	"./svg/paper-plane.svg": 37386,
	"./svg/photo-plus-icon.svg": 34340,
	"./svg/plus-icon.svg": 579,
	"./svg/portfolio-ico.svg": 8513,
	"./svg/portfolio-icon.svg": 64965,
	"./svg/portfoliobackgroundpattern.svg": 31101,
	"./svg/post_card/icons_chart.svg": 72884,
	"./svg/post_card/icons_club.svg": 46400,
	"./svg/post_card/icons_comment.svg": 33155,
	"./svg/post_card/icons_like.svg": 92973,
	"./svg/post_card/icons_like_active.svg": 94598,
	"./svg/post_card/icons_like_filled.svg": 38040,
	"./svg/post_card/icons_like_outline.svg": 50994,
	"./svg/post_card/icons_more.svg": 18799,
	"./svg/post_card/icons_retweet.svg": 63102,
	"./svg/post_card/outlined_post_comment.svg": 95446,
	"./svg/post_card/outlined_post_share.svg": 96876,
	"./svg/post_card/post_comment.svg": 27129,
	"./svg/post_card/post_like_active.svg": 46672,
	"./svg/post_card/post_retweet.svg": 15000,
	"./svg/post_card/post_share.svg": 82967,
	"./svg/post_card/widget--config.svg": 43181,
	"./svg/post_comment.svg": 35399,
	"./svg/post_share.svg": 69217,
	"./svg/prediction-icon-black.svg": 90308,
	"./svg/prediction-icon-yellow.svg": 99427,
	"./svg/price-ico.svg": 84266,
	"./svg/profile-cover-edit-Icon.svg": 87497,
	"./svg/profile-edit-icon-info-two.svg": 28741,
	"./svg/profile-edit-icon-info.svg": 39544,
	"./svg/profile-edit-icon.svg": 8539,
	"./svg/profile-icons/List.svg": 22326,
	"./svg/profile-icons/Playbook.svg": 55071,
	"./svg/profile-icons/Prediction.svg": 59361,
	"./svg/profile-icons/Watchlist.svg": 93411,
	"./svg/profile-icons/favouriteInfluencer.svg": 1770,
	"./svg/profile-icons/favouriteInvestment.svg": 27964,
	"./svg/profile-icons/images2.svg": 85506,
	"./svg/profile-icons/links.svg": 41085,
	"./svg/profile-icons/portfolio.svg": 43578,
	"./svg/profile-icons/profitAndLoss.svg": 12366,
	"./svg/profile-icons/recommendation.svg": 43483,
	"./svg/profile-icons/topStats.svg": 36856,
	"./svg/profile-icons/winningTrades.svg": 49015,
	"./svg/profile_icon_discord.svg": 1919,
	"./svg/profile_icon_facebook.svg": 4609,
	"./svg/profile_icon_instagram.svg": 82051,
	"./svg/profile_icon_linkedin.svg": 33455,
	"./svg/profile_icon_telegram.svg": 17720,
	"./svg/profile_icon_twitch.svg": 88892,
	"./svg/profile_icon_twitter.svg": 26254,
	"./svg/profile_icon_youtube.svg": 34276,
	"./svg/profile_portfolio_bg.svg": 94143,
	"./svg/profile_section_icon/favouriteInfluencer.svg": 15015,
	"./svg/profile_section_icon/favouriteInvestment.svg": 82869,
	"./svg/profile_section_icon/images.svg": 72623,
	"./svg/profile_section_icon/links.svg": 92320,
	"./svg/profile_section_icon/playbook.svg": 69808,
	"./svg/profile_section_icon/points.svg": 31756,
	"./svg/profile_section_icon/portfolio.svg": 64247,
	"./svg/profile_section_icon/predictions.svg": 47973,
	"./svg/profile_section_icon/profitAndLoss.svg": 43403,
	"./svg/profile_section_icon/recommendation.svg": 87296,
	"./svg/profile_section_icon/topStats.svg": 47263,
	"./svg/profile_section_icon/watchlists.svg": 14177,
	"./svg/profile_section_icon/winningTrades.svg": 69074,
	"./svg/profiles_new.svg": 33842,
	"./svg/ranking_icon-01.svg": 37291,
	"./svg/ranking_icon-02.svg": 79224,
	"./svg/ranking_icon-03.svg": 88233,
	"./svg/ranking_icon-04.svg": 18822,
	"./svg/ranking_icon-05.svg": 24151,
	"./svg/remove-friend-outline.svg": 95769,
	"./svg/remove-friend-profile.svg": 73536,
	"./svg/report-friend-profile.svg": 84902,
	"./svg/report-outline.svg": 7452,
	"./svg/report-problem.svg": 91419,
	"./svg/respond-button-icon.svg": 52467,
	"./svg/right-side-par-02.svg": 2994,
	"./svg/right-side-par-03.svg": 6307,
	"./svg/right-side-par.svg": 30039,
	"./svg/search-icon.svg": 37863,
	"./svg/search-input.svg": 21808,
	"./svg/search_new.svg": 25180,
	"./svg/second-leaderboard-icon.svg": 51601,
	"./svg/sectionClose.svg": 42208,
	"./svg/sector-rotation.svg": 29180,
	"./svg/select-stock.svg": 68010,
	"./svg/setting-icon.svg": 51997,
	"./svg/setting.svg": 98233,
	"./svg/settings-icon.svg": 16442,
	"./svg/side_menu/about.svg": 57574,
	"./svg/side_menu/analyze-icon.svg": 86593,
	"./svg/side_menu/analyze.svg": 41325,
	"./svg/side_menu/articles.svg": 45118,
	"./svg/side_menu/card.svg": 17441,
	"./svg/side_menu/dashboard.svg": 76437,
	"./svg/side_menu/discover.svg": 32710,
	"./svg/side_menu/explore.svg": 85056,
	"./svg/side_menu/help.svg": 62370,
	"./svg/side_menu/layers.svg": 48201,
	"./svg/side_menu/logout.svg": 40485,
	"./svg/side_menu/markets.svg": 93742,
	"./svg/side_menu/marketsnew.svg": 79580,
	"./svg/side_menu/portfolio.svg": 34261,
	"./svg/side_menu/portfolio2.svg": 11101,
	"./svg/side_menu/portfolionew.svg": 87925,
	"./svg/side_menu/social.svg": 62506,
	"./svg/side_menu/socialize-alt.svg": 88110,
	"./svg/side_menu/socialize.svg": 68312,
	"./svg/side_menu/timeline.svg": 32798,
	"./svg/singal-back-icon.svg": 52871,
	"./svg/singal-forw-icon.svg": 15216,
	"./svg/socialsIcon/discordIcon.svg": 26640,
	"./svg/socialsIcon/facebookIcon.svg": 4190,
	"./svg/socialsIcon/instagramIcon.svg": 75396,
	"./svg/socialsIcon/linekdinIcon.svg": 72864,
	"./svg/socialsIcon/logo.png": 9326,
	"./svg/socialsIcon/nonVerifiedIcon.svg": 3665,
	"./svg/socialsIcon/redditIcon.svg": 83294,
	"./svg/socialsIcon/telegramIcon.svg": 6019,
	"./svg/socialsIcon/twitterIcon.svg": 13485,
	"./svg/socialsIcon/verifiedCompleteIcon.svg": 81459,
	"./svg/socialsIcon/verifiedPendingIcon.svg": 1221,
	"./svg/sort-arrow-down.svg": 42436,
	"./svg/stats-icon/Icons/icon-analysis.svg": 24498,
	"./svg/stats-icon/Icons/icon-best-trades.svg": 47154,
	"./svg/stats-icon/Icons/icon-charts.svg": 92919,
	"./svg/stats-icon/Icons/icon-chat.svg": 72494,
	"./svg/stats-icon/Icons/icon-explore-tickers.svg": 51367,
	"./svg/stats-icon/Icons/icon-explore-traders.svg": 31517,
	"./svg/stats-icon/Icons/icon-favorite-influencers.svg": 17039,
	"./svg/stats-icon/Icons/icon-favorite-investment.svg": 86922,
	"./svg/stats-icon/Icons/icon-favorite-platform.svg": 14624,
	"./svg/stats-icon/Icons/icon-feed.svg": 38080,
	"./svg/stats-icon/Icons/icon-followers.svg": 24057,
	"./svg/stats-icon/Icons/icon-following.svg": 8861,
	"./svg/stats-icon/Icons/icon-highlights.svg": 19559,
	"./svg/stats-icon/Icons/icon-images.svg": 97682,
	"./svg/stats-icon/Icons/icon-leaderboard.svg": 62025,
	"./svg/stats-icon/Icons/icon-leaderboards.svg": 96072,
	"./svg/stats-icon/Icons/icon-links.svg": 3215,
	"./svg/stats-icon/Icons/icon-overview.svg": 41573,
	"./svg/stats-icon/Icons/icon-playbook.svg": 54993,
	"./svg/stats-icon/Icons/icon-portfolio.svg": 64892,
	"./svg/stats-icon/Icons/icon-portfolio2.svg": 85446,
	"./svg/stats-icon/Icons/icon-predictions.svg": 44066,
	"./svg/stats-icon/Icons/icon-predictions2.svg": 68284,
	"./svg/stats-icon/Icons/icon-profile.svg": 34971,
	"./svg/stats-icon/Icons/icon-profit-loss.svg": 41586,
	"./svg/stats-icon/Icons/icon-recommendations.svg": 15284,
	"./svg/stats-icon/Icons/icon-relations.svg": 35859,
	"./svg/stats-icon/Icons/icon-rofiles.svg": 3450,
	"./svg/stats-icon/Icons/icon-signals.svg": 43507,
	"./svg/stats-icon/Icons/icon-ticker-details.svg": 67943,
	"./svg/stats-icon/Icons/icon-timeline.svg": 41061,
	"./svg/stats-icon/Icons/icon-top-stats.svg": 22511,
	"./svg/stats-icon/Icons/icon-trades.svg": 35025,
	"./svg/stats-icon/Icons/icon-trades2.svg": 97041,
	"./svg/stats-icon/Icons/icon-watchlist.svg": 48861,
	"./svg/stats-icon/icon-avg-gain-dollor.svg": 52308,
	"./svg/stats-icon/icon-avg-gain.svg": 8611,
	"./svg/stats-icon/icon-avg-tm.svg": 5099,
	"./svg/stats-icon/icon-avg-tw.svg": 73889,
	"./svg/stats-icon/icon-best-trade.svg": 46232,
	"./svg/stats-icon/icon-calendar.svg": 14665,
	"./svg/stats-icon/icon-count.svg": 69464,
	"./svg/stats-icon/icon-favorite-influencers.svg": 89152,
	"./svg/stats-icon/icon-favorite-investment.svg": 82915,
	"./svg/stats-icon/icon-favorite-platform.svg": 44437,
	"./svg/stats-icon/icon-followers.svg": 36440,
	"./svg/stats-icon/icon-following.svg": 78860,
	"./svg/stats-icon/icon-friends.svg": 10186,
	"./svg/stats-icon/icon-image.svg": 96754,
	"./svg/stats-icon/icon-investment-dollor.svg": 80405,
	"./svg/stats-icon/icon-investment.svg": 78600,
	"./svg/stats-icon/icon-link.svg": 68335,
	"./svg/stats-icon/icon-list.svg": 70663,
	"./svg/stats-icon/icon-monthly-trade.svg": 59915,
	"./svg/stats-icon/icon-of-trader.svg": 1829,
	"./svg/stats-icon/icon-of-trades.svg": 50660,
	"./svg/stats-icon/icon-outreach.svg": 57270,
	"./svg/stats-icon/icon-playbook.svg": 76574,
	"./svg/stats-icon/icon-prediction.svg": 15976,
	"./svg/stats-icon/icon-price.svg": 62850,
	"./svg/stats-icon/icon-profit-loss.svg": 16895,
	"./svg/stats-icon/icon-recommendation.svg": 38342,
	"./svg/stats-icon/icon-tag.svg": 16901,
	"./svg/stats-icon/icon-top-gain-dollor.svg": 14765,
	"./svg/stats-icon/icon-top-gain.svg": 32864,
	"./svg/stats-icon/icon-trade-price.svg": 83903,
	"./svg/stats-icon/icon-trade.svg": 82175,
	"./svg/stats-icon/icon-trader-type.svg": 90688,
	"./svg/stats-icon/icon-trades-dollor.svg": 60163,
	"./svg/stats-icon/icon-trades.svg": 55998,
	"./svg/stats-icon/icon-users.svg": 14837,
	"./svg/stats-icon/icon-view.svg": 83036,
	"./svg/stats-icon/icon-watchlist.svg": 32100,
	"./svg/stats-icon/icon-week-trade.svg": 80814,
	"./svg/stats-icon/icon-yearly-trades.svg": 89655,
	"./svg/stats-icon/old/icon-calendar.svg": 14431,
	"./svg/stats-icon/old/icon-count.svg": 60938,
	"./svg/stats-icon/old/icon-followers.svg": 950,
	"./svg/stats-icon/old/icon-following.svg": 59522,
	"./svg/stats-icon/old/icon-friends.svg": 15480,
	"./svg/stats-icon/old/icon-investment.svg": 21026,
	"./svg/stats-icon/old/icon-month-trade.svg": 22216,
	"./svg/stats-icon/old/icon-monthly-trade.svg": 56117,
	"./svg/stats-icon/old/icon-outreach.svg": 76508,
	"./svg/stats-icon/old/icon-price.svg": 12560,
	"./svg/stats-icon/old/icon-tag.svg": 22327,
	"./svg/stats-icon/old/icon-trade-price.svg": 20353,
	"./svg/stats-icon/old/icon-trade.svg": 51833,
	"./svg/stats-icon/old/icon-users.svg": 33391,
	"./svg/stats-icon/old/icon-view.svg": 28558,
	"./svg/stats-icon/old/icon-week-trade.svg": 35476,
	"./svg/stock-pricing-up-icon.svg": 23598,
	"./svg/stocks-icon.svg": 19736,
	"./svg/telegram.svg": 88610,
	"./svg/text-post-edit-icon.svg": 37332,
	"./svg/theme.svg": 14174,
	"./svg/thumbs-up.svg": 62974,
	"./svg/tick.svg": 33940,
	"./svg/timeline-Icon-2.svg": 30785,
	"./svg/timeline-icon.svg": 17564,
	"./svg/timelinetabicon.svg": 64224,
	"./svg/times-red-icon.svg": 71617,
	"./svg/traderverse-trademark.svg": 31960,
	"./svg/tradesUp-icon.svg": 64821,
	"./svg/trading_view_logo.svg": 80496,
	"./svg/twitch.svg": 54102,
	"./svg/twitter-icon.svg": 43206,
	"./svg/twitter.svg": 38484,
	"./svg/two-users.svg": 96484,
	"./svg/unfollow-friend-profile.svg": 70170,
	"./svg/unfollow-outline.svg": 7136,
	"./svg/user-block.svg": 95510,
	"./svg/user3.svg": 87137,
	"./svg/users-icon.svg": 7381,
	"./svg/vertical-dots.svg": 58458,
	"./svg/view-all-icon.svg": 4432,
	"./svg/view-icon.svg": 51818,
	"./svg/wallet-icon.svg": 66334,
	"./svg/widget-size/1.svg": 10307,
	"./svg/widget-size/2.svg": 20912,
	"./svg/widget-size/3.svg": 12033,
	"./svg/widgetbox-1.svg": 48804,
	"./svg/widgetbox-2.svg": 3255,
	"./svg/widgetbox-3.svg": 14278,
	"./svg/widgets-catergory/icon-trader.svg": 5828,
	"./svg/widgets_market_01.svg": 41941,
	"./svg/widgets_market_02.svg": 694,
	"./svg/widgets_market_03.svg": 87815,
	"./svg/widgets_market_04.svg": 68008,
	"./svg/widgets_market_05.svg": 75929,
	"./svg/widgets_market_06.svg": 31530,
	"./svg/widgets_market_07.svg": 49371,
	"./svg/widgets_market_08.svg": 98108,
	"./svg/widgets_market_09.svg": 52381,
	"./svg/widgets_market_10.svg": 83255,
	"./svg/widgets_market_11.svg": 95718,
	"./svg/widgets_market_12.svg": 94853,
	"./svg/widgets_market_13.svg": 40132,
	"./svg/widgets_market_14.svg": 2283,
	"./svg/widgets_market_15.svg": 99578,
	"./svg/widgets_market_16.svg": 98313,
	"./svg/widgets_market_17.svg": 63448,
	"./svg/widgets_market_18.svg": 66335,
	"./svg/widgets_market_19.svg": 45230,
	"./svg/widgets_market_20.svg": 67810,
	"./svg/widgets_market_21.svg": 71539,
	"./svg/widgets_market_22.svg": 10528,
	"./svg/widgets_market_23.svg": 24913,
	"./svg/widgets_market_24.svg": 13358,
	"./svg/widgets_market_25.svg": 27999,
	"./svg/widgets_market_26.svg": 48972,
	"./svg/widgets_market_27.svg": 96333,
	"./svg/widgets_market_28.svg": 81978,
	"./svg/widgets_market_29.svg": 75851,
	"./svg/widgets_market_30.svg": 91357,
	"./svg/widgets_market_31.svg": 1884,
	"./svg/widgets_market_32.svg": 80911,
	"./svg/widgets_market_33.svg": 37182,
	"./svg/widgets_market_34.svg": 50561,
	"./svg/widgets_market_35.svg": 15024,
	"./svg/widgets_market_36.svg": 72067,
	"./svg/widgets_market_37.svg": 57426,
	"./svg/widgets_market_event_calendar.svg": 69329,
	"./svg/widgets_market_event_table.svg": 28705,
	"./svg/widgets_market_financials.svg": 20000,
	"./svg/widgets_market_monthly_seasonality.svg": 95582,
	"./svg/widgets_market_price_performance.svg": 79836,
	"./svg/widgets_market_pulse.svg": 43663,
	"./svg/wining-trades-background.svg": 8628,
	"./svg/x-icon.svg": 23529,
	"./svg/youtube-icon.svg": 20212,
	"./svg/youtube.svg": 54762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66742;